import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import "./style.css";
import { configuration } from "../appConfig";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CarDentTableAut extends Component {
  state = {
    data: {},
    words: {},
    lang: "de",
    ShowAW : false
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  componentDidMount() {
    // const partnerId = localStorage.getItem("partnerId");
    // const vin = localStorage.getItem("selectedFile");
    // Axios.get(
    //   `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    // ).then((r) => {
    //   if (r.data) {
    //     this.setState({ data: r.data,
    //         Dents: r.data.Dents,
    //          ShowAW: r.data.hasOwnProperty("ShowAW") ? r.data.ShowAW : false });
    //   }
    // });
    this.getLang();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data!== this.props.data) {
      this.setState({data :this.props.data, Dents: this.props.data.Dents,
                 ShowAW: this.props.data.hasOwnProperty("ShowAW") ? this.props.data.ShowAW : false})
    }
  }
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

//   decimalAdjust = (type, value, exp) => {
//     // If the exp is undefined or zero...
//     if (typeof exp === 'undefined' || +exp === 0) {
//         return Math[type](value);
//     }
//     value = +value;
//     exp = +exp;
//     // If the value is not a number or the exp is not an integer...
//     if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
//         return NaN;
//     }
//     // Shift
//     value = value.toString().split('e');
//     value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
//     // Shift back
//     value = value.toString().split('e');
//     return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
// }

round10 = (value, exp) => this.decimalAdjust('round', value, exp);

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    const vin = localStorage.getItem("selectedFile");
    const { data, ShowAW, Dents } = this.state;
    function findWithAttr(array, attr, value) {
      for(var i = 0; i < array.length; i += 1) {
          if(array[i][attr] === value) {
              return i;
          }
      }
      return -1;
    }
    // const { Dents } = this.state;
    // function findWithAttr(array, attr, value) {
    //   for(var i = 0; i < array.length; i += 1) {
    //       if(array[i][attr] === value) {
    //           return i;
    //       }
    //   }
    //   return -1;
    // }
//     var order = [
//         "Hood",
//         "Roof",
//         "TrunkCover",
//         "LeftRoofFrame",
//         "LeftFrontFender",
//         "LeftFrontDoor",
//         "LeftBackDoor",
//         "LeftBackFender",
//         "RightRoofFrame",
//         "RightBackFender",
//         "RightBackDoor",
//         "RightFrontDoor",
//         "RightFrontFender",
//       ];
      
//       data.Dents.sort(function(a, b) {
//         // sort based on the index in order Dents
//         return order.indexOf(a.Part) - order.indexOf(b.Part);
//       })
    return (
      <div className="row p-0 text-muted hide-report">
        <div className="table-responsive">
          <table className="table table-bordered table-striped dent-table-2d text-center">
            <thead>
              <tr>
                <th>{this.lang("Part")}</th>
                <th>{this.lang("Light-at")}</th>
                <th>{this.lang("Medium")}</th>
                <th>{this.lang("Heavy")}</th>
              
              </tr>
            </thead>
            <tbody>
              {data.Dents &&
                data.Dents.length &&
                data.Dents.map((row, i) => {
                    return (
                        row.Part !== "LeftFrontTyre" &&
                        row.Part !== "LeftBackTyre" &&
                        row.Part !== "RightFrontTyre" &&
                        row.Part !== "RightBackTyre" &&
                        row.Part !== "FrontBumper" &&
                        row.Part !== "BackBumper" &&
                        row.Part !== "Underbody" &&
                        row.Part !== "Trunk" &&
                        row.Part !== "Inside" && (
                           <tr key={i}>
                              <td style={{ textAlign: "left" }}>{this.lang(`${row.Part}-at`).split("(")[0]}</td>
                              <td style={{}}>{row.Part === "TrunkCover" ? row.A + Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A : row.A}</td>
                                <td style={{}}>{row.Part === "TrunkCover" ? row.B + Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : row.B}</td>
                                <td style={{}}>{row.Part === "TrunkCover" ? row.C + Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : row.C}</td>
                              </tr>
                        )
                    )
                })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CarDentTableAut);
